import { t } from 'i18next';
import { contractTypeEnum } from '../user';

export const contractTypeLabels: Record<number, string> = {
    [contractTypeEnum.APPRENTICE]: 'apprentice',
    [contractTypeEnum.FIXED_TERM]: 'fixedTerm',
    [contractTypeEnum.INTERN]: 'intern',
    [contractTypeEnum.OTHER]: 'other',
    [contractTypeEnum.PERMANENT]: 'permanent',
    [contractTypeEnum.TEMPWORKER]: 'tempWorker',
    [contractTypeEnum.SUBCONTRACTOR]: 'subContractor',
};

export const getContractTypeLabel = (type?: number): string => {
    return type !== undefined && contractTypeLabels[type] ? t(contractTypeLabels[type]) : '';
};
